import immutableUpdate from 'immutable-update' 
import utils from './utils'
import React, {
  useEffect,
  useReducer,
  useRef
} from 'react'
import { 
  useParams
} from 'react-router-dom'
import { 
  useUser 
} from 'data/hooks'
import {
  Content
} from 'basecomps'
import {
  reducer,
  initialstate
 } from './reducer'

export const ContentEvaluable = props => {

  const contentevaluableref = useRef()
  const params = useParams()
  const { userId } = useUser()
  const gameId = params.gameId || playmotiv.game.gameId
  const { eventId } = useParams()

  // -----------------------------------------
  // State

  const [state, dispatch] = useReducer(reducer, initialstate) 

  // -----------------------------------------
  // Slider slides

  useEffect(() => {

    let startwwaittime = new Date().getTime()

    if(contentevaluableref.current && !state.current) {

      const waitSlides = setInterval(() => {

        if(!contentevaluableref.current) {

          clearInterval(waitSlides)

          return
        }

        const slides = contentevaluableref.current.getElementsByClassName('wp-block-playmotivcloud-slide')

        if(slides.length) {

          clearInterval(waitSlides)

          const slidescontainer = contentevaluableref.current.getElementsByClassName('wp-block-playmotivcloud-content')
          const slidescontainertype = slidescontainer.item(0).getAttribute('data-contenttype')          
          
          if(slidescontainertype == 'slider') {

            dispatch({
              isslider: true,
              domslides: slides
            })

            slides.item(0).className += ' visible'
          }

        } else {

          const newwaittime = new Date().getTime()
          const diff = newwaittime - startwwaittime

          if(diff > 1500) {

            clearInterval(waitSlides)

            /// console.log('Slides not found in 1.5 sec') // Check if need up wait time
          }
        }

      }, 300)

      dispatch({
        current: true
      }) // Hack for simple render
    }

  }, [contentevaluableref.current])

  // -----------------------------------------
  // Events

  const eventlistener = e => {
    
    dispatch({
      type: 'EVENT',
      payload: {
        type: e.type,
        blockid: e.detail.blockid,
        event: e.detail.event,
        data: e.detail.data
      }
    })    
    
    dispatch({
      type: 'UPDATE'
    })      
    
    dispatch({
      type: 'UPDATESLIDES'
    })   
    
    dispatch({
      type: 'SAVESTATE'
    })
  }

  useEffect(() => { 

    dispatch({
      gameid: gameId,
      userid: userId,
      eventid: eventId
    })

    document.addEventListener(
      'playmotiv_contentevaluable',
      eventlistener
    )

    return () => {

      document.removeEventListener(
        'playmotiv_contentevaluable',
        eventlistener
      )      
    }
  }, []) 

  // -----------------------------------------
  // Wrapper component

  return <div 
    className="contentevaluable"
    ref={ contentevaluableref }    
    onClick={ e => utils.click(state, dispatch, e) }
  >
    <Content
      { ...props }
      blocks={ blocks => utils.blocks(dispatch, blocks) }
    />
    {
      state.isslider &&
      props.withbuttons &&
      state.actualSlide > 0 &&
      <div 
        className="prev"
        onClick={ () => utils.navslide(-1, state, dispatch) }
      />
    }
    {
      state.isslider &&
      props.withbuttons &&
      (
        !state.blockslides[state.actualSlide].interceptor
        ||
        (
          state.blockslides[state.actualSlide].interceptor
          &&
          state.blockslides[state.actualSlide].completed
        )
      ) &&
      state.actualSlide < state.domslides.length - 1 &&
      <div 
        className="next"
        onClick={ () => utils.navslide(1, state, dispatch) }
      />
    }
  </div>
}
